import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { Resolver, useForm } from 'react-hook-form'
import { DEFAULT_MILKING_VALUES } from '../constants/defaultValues'
import { IMilkingForm } from '../types/milkingForm'
import { shiftSchema } from '../validationSchema'
import { useGetMilkingScheduleSettingsQuery } from './useGetMilkingScheduleSettingsQuery'

export const useMilkingSettingsForm = () => {
	const { data, isLoading, isError, refetch } =
		useGetMilkingScheduleSettingsQuery()

	const form = useForm<IMilkingForm>({
		defaultValues: DEFAULT_MILKING_VALUES,
		mode: 'onChange',
		resolver: yupResolver(shiftSchema) as Resolver<IMilkingForm>,
	})

	useEffect(() => {
		if (data) {
			const amDeviation =
				data?.[0]?.am_allowed_deviation_seconds != null
					? Math.floor(data[0].am_allowed_deviation_seconds / 60).toString()
					: ''

			const pmDeviation =
				data?.[0]?.pm_allowed_deviation_seconds != null
					? Math.floor(data[0].pm_allowed_deviation_seconds / 60).toString()
					: ''

			const nightDeviation =
				data?.[0]?.night_allowed_deviation_seconds != null
					? Math.floor(data[0].night_allowed_deviation_seconds / 60).toString()
					: ''

			const newValues: IMilkingForm = {
				am: {
					halls:
						data?.map(item => ({
							milk_hall: item.milk_hall,
							start: item.am_period_start,
							end: item.am_period_end,
						})) ?? [],
				},
				pm: {
					halls:
						data?.map(item => ({
							milk_hall: item.milk_hall,
							start: item.pm_period_start,
							end: item.pm_period_end,
						})) ?? [],
				},
				night: {
					halls:
						data?.map(item => ({
							milk_hall: item.milk_hall,
							start: item.night_period_start,
							end: item.night_period_end,
						})) ?? [],
				},
				am_allowed_deviation_seconds: amDeviation,
				pm_allowed_deviation_seconds: pmDeviation,
				night_allowed_deviation_seconds: nightDeviation,
			}

			form.reset(newValues)
		}
	}, [data, form])

	return {
		form,
		isLoading,
		isError,
		refetch,
	}
}
